import React, { createContext, useContext, useState, useCallback } from 'react';

interface SeoCannibalizationEditorContextType {
  isOpen: boolean;
  openEditor: () => void;
  closeEditor: () => void;
}

const SeoCannibalizationEditorContext = createContext<SeoCannibalizationEditorContextType | undefined>(undefined);

export function SeoCannibalizationEditorProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openEditor = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeEditor = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <SeoCannibalizationEditorContext.Provider
      value={{
        isOpen,
        openEditor,
        closeEditor,
      }}
    >
      {children}
    </SeoCannibalizationEditorContext.Provider>
  );
}

export function useSeoCannibalizationEditor() {
  const context = useContext(SeoCannibalizationEditorContext);
  if (!context) {
    throw new Error('useSeoCannibalizationEditor must be used within SeoCannibalizationEditorProvider');
  }
  return context;
}
